import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_9 = {
  class: "alert alert-info mb-3",
  role: "alert"
}
const _hoisted_10 = { class: "list-group" }
const _hoisted_11 = ["onClick", "aria-pressed", "title"]
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_14 = {
  key: 0,
  class: "list-group-item text-muted small"
}
const _hoisted_15 = { class: "modal-footer" }
const _hoisted_16 = ["disabled"]

import { computed, toRef } from 'vue'
    import type { ProjectPlanPickerDialogViewModel } from "@Quest/PortfolioScenarios/Components/ProjectPlanPickerDialog"

    type PlanItem = { Id: string; Name: string; CreatedAt?: string }

    // props
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectPlanPickerDialog',
  props: {
    viewModel: {}
  },
  emits: ["confirmed"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    // emits
    const emit = __emit

    // vm shortcut
    const vm = toRef(props, 'viewModel')

    // state
    const opened = computed(() => !!vm.value?.opened)
    const initialized = computed(() => !!vm.value.initialized)

    const projectName = computed(() => vm.value.projectName || 'Project')
    const plans = computed<PlanItem[]>(() => vm.value.plans as unknown as PlanItem[])
    const activePlanId = computed(() => vm.value.activePlanId)

    const lockedPlanId = computed<string | null>({
        get: () => vm.value.lockedPlanId,
        set: v => vm.value.lockedPlanId = v
    })

    const canConfirm = computed(() => initialized.value)

    // derived list
    const orderedPlans = computed<PlanItem[]>(() =>
    {
        const arr = [...plans.value]
        const active = activePlanId.value
            ? arr.find(p => p.Id === activePlanId.value)
            : undefined

        const rest = arr.filter(p => p.Id !== activePlanId.value)

        rest.sort((a, b) =>
        {
            const ad = a.CreatedAt ? Date.parse(a.CreatedAt) : NaN
            const bd = b.CreatedAt ? Date.parse(b.CreatedAt) : NaN
            if (!Number.isNaN(ad) && !Number.isNaN(bd)) return bd - ad
            if (!Number.isNaN(ad)) return -1
            if (!Number.isNaN(bd)) return 1
            return a.Name.localeCompare(b.Name)
        })

        return active ? [active, ...rest] : rest
    })

    // actions
    function toggleLock(id: string)
    {
        lockedPlanId.value = lockedPlanId.value === id ? null : id
    }

    function resetToDefault()
    {
        lockedPlanId.value = null
    }

    function handleConfirm()
    {
        emit('confirmed', {
            projectId: vm.value.projectId,
            lockedPlanId: lockedPlanId.value
        })
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, "Lock a plan version: " + _toDisplayString(projectName.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close",
                  "aria-label": "Close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createCommentVNode(" Loading "),
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("h5", null, [
                        _createElementVNode("i", { class: "fa fa-spinner fa-spin mr-2" }),
                        _createTextVNode(" Loading plans... ")
                      ], -1 /* CACHED */)
                    ]))]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" Loaded "),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_9, [
                          _cache[1] || (_cache[1] = _createTextVNode(" By default, this scenario always follows the project’s current ", -1 /* CACHED */)),
                          _cache[2] || (_cache[2] = _createElementVNode("em", null, "Active", -1 /* CACHED */)),
                          _cache[3] || (_cache[3] = _createTextVNode(" plan. You can lock it to a specific version below if needed. ", -1 /* CACHED */)),
                          (lockedPlanId.value !== null)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-link p-0 align-baseline",
                                onClick: resetToDefault
                              }, " Reset to default "))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderedPlans.value, (p) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: p.Id,
                              type: "button",
                              class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center plan-row",
                              onClick: ($event: any) => (toggleLock(p.Id)),
                              "aria-pressed": lockedPlanId.value === p.Id,
                              title: p.Name
                            }, [
                              _createElementVNode("span", _hoisted_12, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["mr-2", lockedPlanId.value === p.Id ? 'fa-solid fa-circle-check text-primary' : 'fa-regular fa-circle text-muted']),
                                  "aria-hidden": "true"
                                }, null, 2 /* CLASS */),
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'font-weight-semibold': lockedPlanId.value === p.Id })
                                }, _toDisplayString(p.Name), 3 /* TEXT, CLASS */)
                              ]),
                              (p.Id === activePlanId.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Active"))
                                : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_11))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (orderedPlans.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No plans found for this project. "))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: handleConfirm,
                  type: "button",
                  class: "btn btn-primary",
                  disabled: !canConfirm.value
                }, " Confirm ", 8 /* PROPS */, _hoisted_16)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})